// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TopNavigation_wrapper__P0r32","burgerWhite":"TopNavigation_burgerWhite__EZwWW"};